import { Component, inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AppService } from '@app/app.service';
import { AngularEditorConfig } from '@components/angular-editor/config';
import { FieldConfig } from '../field.interface';

@Component({
    selector: 'app-wysiwyg',
    templateUrl: './wysiwyg.component.html',
    styleUrls: ['./wysiwyg.component.scss'],
})
export class WysiwygComponent implements OnInit {
    readonly appService = inject(AppService);

    field: FieldConfig;
    group: FormGroup;

    isLoad = false;

    public editorConfig: AngularEditorConfig = null;

    ngOnInit() {
        this.editorConfig = this.initConfig();
        if (!!this.field?.wysiwygDisableButtons && this.field?.wysiwygDisableButtons.length > 0) {
            this.editorConfig.toolbarHiddenButtons = this.field?.wysiwygDisableButtons;
        }
        this.isLoad = true;
    }

    private initConfig(): AngularEditorConfig {
        return {
            editable: !this.field?.disabled,
            enableToolbar: !this.field?.disabled,
            showToolbar: !this.field?.disabled,
            spellcheck: !this.field?.disabled,
            height: 'auto',
            minHeight: '120px',
            maxHeight: 'auto',
            width: 'auto',
            minWidth: '0',
            translate: 'yes',
            defaultParagraphSeparator: '',
            defaultFontName: '',
            defaultFontSize: '',
            fonts: [
                { class: 'arial', name: 'Arial' },
                { class: 'roboto', name: 'Roboto' },
            ],
            uploadUrl: '',
            uploadWithCredentials: false,
            sanitize: false,
            toolbarPosition: 'top',
            outline: true,
            followLinkText: this.appService.language_dictionary.followLinkText,
        };
    }
}
